
import { Component, Vue, Watch } from "vue-property-decorator";
import { LogHelper } from "@/common/LogHelper";
import { LineListcodename } from "@/views/components";
import { getOrgCodeListByPage } from "@/api/service";
import { ScanforDepartModule } from "@/store/modules/store_scanfordepart";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

@Component({
  name: "Form1",
  components: { LineListcodename },
})
export default class extends Vue {
  private inputModel: inputDataModel_Depart = {
    checked_NextOrgCode: false,
    input_ScanCode: "",
    input_CarSignNum: "",
    input_LineNo: "",
    input_LineName: "",
    input_NextOrgCode: "",
    input_OrgName: "",
    checked_OverTimeCar: false,
    options_NextOrg: [],
  };
  public globalConfig: any = {};

  mounted() {
    this.$emit("get-form1-value", this.inputModel);
    this.globalConfig = SystemConfigModule.globalData;
  }
  @Watch("inputModel", { deep: true })
  onChildChanged(val: string) {
    this.$emit("get-form1-value", val);
  }

  private linelistdialogshow = false;
  public linelistcodenameFunc(linelistModel) {
    this.linelistdialogshow = false;
    if (linelistModel != null) {
      this.inputModel.input_LineNo = linelistModel.lineNo;
      this.inputModel.input_LineName = linelistModel.lineName;
      let _result = this.GetNextOrg(linelistModel.lineNo);
      this.getNextOrgCallback(_result);
    }
  }
  //获取下一网点
  public GetNextOrg(id) {
    try {
      if (this.IsNullorEmptyorUndefined(id)) {
        return;
      }
      var result = this.GetLineDetail(id);
      if (result == null) {
        try {
          ScanforDepartModule.setErrorMessage("发车:GetLineDetail返回值为空");
        } catch (ex) {
          LogHelper.Error("【发车】获取下一网点失败：" + ex.toString());
        }
      }
      return result;
    } catch (ex) {
      LogHelper.Error("【发车】获取下一网点：" + ex.toString());
    }
  }
  public GetLineDetail(lineId) {
    let body = {
      queryValue: lineId, //过滤字符串
      queryType: "21",
      viewType: "1",
      extend1: "", //当前页
      extend2: "", //页大小
      extend3: "", //过滤字段
    };
    let job = {
      devMac: "00-00-00-00-00-00",
      devType: "0",
      body: body,
    };
    let responseStr = getOrgCodeListByPage(JSON.stringify(job));
    let response = JSON.parse(responseStr);
    return response;
  }
  //字符串为null、空、未定义判断
  private IsNullorEmptyorUndefined(data) {
    if (data == null || data == undefined || data == "") {
      return true;
    } else {
      return false;
    }
  }
  // public options_NextOrg = [];
  //下一网点界面更新判定
  private getNextOrgCallback(jsonobj) {
    if (jsonobj.data.busiDataArray != null) {
      this.inputModel.options_NextOrg = [];
      jsonobj.data.busiDataArray.forEach((element) => {
        this.inputModel.options_NextOrg.push({
          label: element.endOrgName,
          value: element.endOrgCode,
        });
      });
      if (this.inputModel.options_NextOrg.length > 0) {
        this.inputModel.input_OrgName =
          this.inputModel.options_NextOrg[this.inputModel.options_NextOrg.length - 1].label;
        this.inputModel.input_NextOrgCode =
          this.inputModel.options_NextOrg[this.inputModel.options_NextOrg.length - 1].value;
      } else {
        this.inputModel.input_OrgName = "";
        this.inputModel.input_NextOrgCode = "";
      }
    }
  }
  public findlinelistcodename() {
    this.linelistdialogshow = true;
  }
  private clearlinecodename() {
    this.inputModel.input_LineNo = "";
    this.inputModel.input_LineName = "";
  }
  //下一网点选择
  private chooseNextOrgCode(item): void {
    this.inputModel.input_NextOrgCode = item.value;
  }
  //显示信息栏
  public messageboxShow(type, msg): void {
    // info
    // warning
    // success
    // error
    this.$message({
      message: msg,
      type: type,
    });
  }

  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  //表格选中当前行
  public setCurrent(row) {
    this.$refs.singleTable[0].setCurrentRow();
  }
}
